module.exports = __webpack_public_path__ + "static/media/hotel.090b74cc.svg";